export default __webpack_public_path__ + "static/media/8image.0f75628c.png";